import { render } from "preact";
import { useState } from "preact/hooks";
import { encrypt } from "../encrypt";
import { LazyCss } from "../components/css";

const questions = [
  { title: "What's your name?", key: "name" },
  { title: "What's the name of your organization?", key: "organization" },
  { title: "What's your role?", key: "role" },
  { title: "How many employees do you have?", key: "numEmployees" },
  {
    title: "What's your motivation for a SOC 2 audit?",
    key: "motivation",
    type: "textarea",
  },
  {
    title: "Do you already have a compliance platform (e.g. Vanta, Drata)?",
    key: "compliancePlatform",
  },
  {
    title: "What cloud computing provider(s) do you use?",
    key: "cloud",
  },
  {
    title: "Do you have a hard deadline or a target date?",
    key: "deadline",
  },
  {
    title: "How did you hear about us?",
    key: "source",
  },
];

const SignupPage = () => {
  const [status, setStatus] = useState(undefined);
  async function encryptAndMail(evt) {
    evt.preventDefault();
    const formData = new FormData(evt.currentTarget);
    const formJson = {};
    for (const [k, v] of formData.entries()) {
      formJson[k] = v;
    }
    const encrypted = await encrypt(JSON.stringify(formJson));
    window.location.href = `mailto:hello@monorail.tech?subject=${encodeURIComponent(`${formJson.organization}: interested in SOC 2`)}&body=${encodeURIComponent(`Hi there!\n\nHere's my form response: \n\n ${encrypted}\n\n`)}`;
    // TODO handle errors
    setStatus("sent");
  }
  return (
    <>
      <LazyCss url="https://fonts.googleapis.com/css2?family=Atkinson+Hyperlegible:ital,wght@0,400;0,700;1,400;1,700&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" />
      <LazyCss url="https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,300;0,400;0,500;1,300;1,400;1,500&display=swap" />
      <div class="bg-monorail min-h-full p-2 md:p-8 monorail-sans">
        <section class="bg-gray-50 max-w-2xl m-auto p-6 shadow-lg rounded-sm">
          <h1 class="text-2xl md:text-3xl font-semibold monorail-header">
            Monorail Technology{" "}
            <span class="block md:inline font-light">SOC 2 interest form</span>
          </h1>
          {status === "sent" && (
            <p class="my-6">
              Thanks! Go ahead and send the email draft that should have popped
              up, and we'll get back to you shortly.
            </p>
          )}
          {status === undefined && (
            <>
              <p class="mt-2 text-sm sm:text-base text-gray-600">
                Tell us a little bit about your company or organization, and
                we'll get in touch soon!
              </p>
              <p class="mt-2 text-sm sm:text-base text-gray-600">
                When you're done, this form will generate an email draft with an
                encrypted version of your responses that can only be read by
                Monorail.
              </p>
              <form onSubmit={encryptAndMail}>
                {questions.map((q) => (
                  <fieldset class="fieldset mt-6">
                    <legend class="text-base md:text-lg font-medium mb-1">
                      {q.title}
                    </legend>
                    {q.type === undefined && (
                      <input
                        type="text monorail-sans"
                        name={q.key}
                        class="input validator text-base md:text-lg w-full"
                        required
                      />
                    )}
                    {q.type === "textarea" && (
                      <textarea
                        class="textarea w-full validator text-base md:text-lg"
                        name={q.key}
                        required
                      ></textarea>
                    )}
                  </fieldset>
                ))}
                <button class="btn btn-active btn-primary mt-6 mb-2 w-full sm:w-auto text-base">
                  <svg
                    aria-label="Email icon"
                    width="16"
                    height="16"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <g
                      stroke-linejoin="round"
                      stroke-linecap="round"
                      stroke-width="2"
                      fill="none"
                      stroke="white"
                    >
                      <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                    </g>
                  </svg>
                  Send to Monorail &rarr;
                </button>
              </form>
            </>
          )}
        </section>
      </div>
    </>
  );
};

render(<SignupPage />, document.querySelector("main"));
